import { Injectable } from '@angular/core';
import { ProgressSpinnerComponent } from './progress-spinner.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ProgressSpinnerService {
  progressSpinnerRef!: MatDialogRef<any>;

  constructor(public dialog: MatDialog) {}

  openProgressSpinner() {
    this.progressSpinnerRef = this.dialog.open(ProgressSpinnerComponent, {
      width: '250px',
      panelClass: 'custom-modalbox',
    });
  }

  closeProgressSpinner() {
    this.progressSpinnerRef.close();
  }
}
